import{a as o}from"./chunk-QEKOZYJ5.js";import{a as r}from"./chunk-RAAYCPUM.js";function m(...n){return r(i,n)}function i(n,d,e){let u=e(d,void 0,n);return o(n,(a,t)=>e(a,t,n)<u)}export{m as a};
